import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";
import GridViewIcon from '@mui/icons-material/GridView';
import PowerOutlinedIcon from '@mui/icons-material/PowerOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const adminMenus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "menu_item",
            name: "Dashboard",
            key: "admin",
            icon: <GridViewIcon />,
            route: "/admin",
            privacy: "private",
        },
        {
            type: "menu_item",
            name: "Plugins",
            key: "plugins",
            icon: <PowerOutlinedIcon />,
            route: "/admin/plugins",
            privacy: "private",
        },
        {
            type: "menu_item",
            name: "Configuration",
            key: "configuration",
            icon: <SettingsOutlinedIcon />,
            route: "/admin/configuration",
            privacy: "private",
        },
        {
            type: "menu_item",
            name: "Return Home",
            key: "exit_admin",
            icon: <Icon fontSize="medium">arrow_back_outlined</Icon>,
            route: "/home",
            privacy: "private",
        }
    ];
};

export default adminMenus;